// ── 6 Erster Tenant-Admin ── das Formular.

import { Note } from "../../ui/badge";
import { Field, Input } from "../../ui/field";
import type { FirstAdminState } from "./first-admin";
import { fieldError, setter } from "./shared";
import type { StepFormProps } from "./types";

export function FirstAdminForm({ tenant: t, state, setState, check }: StepFormProps<FirstAdminState>) {
  const set = setter(setState);
  const local = t.auth.modes.includes("local");
  const err = fieldError(check, "email");
  return (
    <>
      <div className="pf-grid">
        <Field label="E-Mail" error={err}>
          <Input name="email" type="email" value={state.email} invalid={!!err} onChange={(e) => set("email")(e.target.value)} />
        </Field>
        <Field label="Name (optional)">
          <Input name="name" value={state.name} onChange={(e) => set("name")(e.target.value)} />
        </Field>
      </div>
      <Note>
        {local
          ? "Lokale Konten: die Instanz verschickt eine Einladung zum Passwortsetzen. Ohne SMTP erscheint der Link nach der Einrichtung hier, einmal, zum Kopieren."
          : "Die erste Anmeldung mit dieser E-Mail übernimmt das freigeschaltete Admin-Konto."}
      </Note>
    </>
  );
}
